import { EPOCH_CONFIGS, STAKING_ENDPOINTS, WEEK } from '../constants/staking.js';
export function getEpochDetails(epoch, config = EPOCH_CONFIGS.default) {
    const currentEpochTime = config.epochStart + WEEK * epoch;
    const epochEndTime = currentEpochTime + WEEK;
    return { epochStart: currentEpochTime, epochEnd: epochEndTime };
}
export function getEpochPeriod(config = EPOCH_CONFIGS.default) {
    const timestamp = Math.floor(Date.now() / 1000);
    return Math.floor((timestamp - config.epochStart) / WEEK);
}
export const getStakingGqlEndpoint = (networkId) => {
    return STAKING_ENDPOINTS[networkId] || STAKING_ENDPOINTS[10];
};
//# sourceMappingURL=staking.js.map